export default __webpack_public_path__ + "static/media/IMG-20220728-WA0008.1b9bdad8.jpg";